import V2Container from '@/common/components/Data/V2Container';
import { useMethods } from '@lhb/hook';
import { Form, Modal } from 'antd';
import { FC, useEffect, useState } from 'react';
import styles from './index.module.less';
import Filter from './Filter';
import V2Table from '@/common/components/Data/V2Table';
import { getExportDataList } from '@/common/api/common';
import { downloadFile, isArray, isNotEmptyAny, refactorPermissions } from '@lhb/func';
import V2Operate from '@/common/components/Others/V2Operate';

/**
 * @Description 导出记录弹窗列表
 */
const DownLoadRecord:FC<{
  visible: boolean;
  setVisible: any;
}> = ({ visible, setVisible }) => {
  const [searchParams, setSearchParams] = useState<any>();
  const [mainHeight, setMainHeight] = useState<number>(0);
  const [searchForm] = Form.useForm();
  const columns = [
    // { key: 'number', title: '文件编号', width: 150 },
    { key: 'exportTime', title: '操作时间', width: 180 },
    { key: 'menuName', title: '所属菜单', width: 180 },
    { key: 'fileName', title: '文件名称' },
    { key: 'statusName', title: '状态', width: 100, render(value, record) {
      const color = record.status === 1 ? '#FFA958' : record.status === 2 ? '#58EC9D' : '#FF7F7F';
      return <div className={styles.status}><div className={styles.circle} style={{ background: color }}/>{value}</div>;
    } },
    { key: 'permissions', title: '操作', width: 100, render(value, record) {
      const oprateList = refactorPermissions(value);
      return isNotEmptyAny(oprateList) ? <V2Operate operateList={oprateList} onClick={(btn) => methods[btn?.func](record)}/> : '-';
    } },
  ];

  useEffect(() => {
    if (visible) {
      searchForm.resetFields();
      setSearchParams({ fileName: null, time: [] });
    }
  }, [visible]);

  const methods = useMethods({
    async loadData(params) {
      const newParams = {
        ...params,
        ...searchParams,
        fromExportDate: isArray(searchParams?.time) && searchParams.time?.[0] ? searchParams.time[0] : null,
        toExportDate: isArray(searchParams?.time) && searchParams.time?.[1] ? searchParams.time[1] : null,
      };
      const res = await getExportDataList(newParams);
      return {
        dataSource: isArray(res?.objectList) ? res?.objectList : [],
        count: res?.totalNum || 0,
      };
    },
    handleClose() {
      setVisible(false);
    },
    handleRefresh() {
      setSearchParams({ ...searchParams });
    },
    handleDownload(item) {
      downloadFile({
        name: item.fileName,
        url: item.fileUrl
      });
    }
  });
  return (
    <Modal
      open={visible}
      width='60vw'
      footer={null}
      onCancel={() => setVisible(false)}
      className={styles.containerWrapper}
      style={{ minWidth: 628 }}
    >
      <V2Container
        className={styles.container}
        style={{ height: '70vh', minHeight: 400 }}
        emitMainHeight={(h) => setMainHeight(h)}
        extraContent={{
          top: <Filter searchForm={searchForm} setSearchParams={setSearchParams}/>
        }}>
        <V2Table
          rowKey='id'
          filters={searchParams}
          defaultColumns={columns}
          onFetch={methods.loadData}
          emptyRender
          voluntarilyEmpty
          scroll={{ y: mainHeight - 80 }}/>
      </V2Container>
    </Modal>
  );
};

export default DownLoadRecord;
